import { defineStore } from "pinia";

export const useSocmedStore = defineStore("SocmedStore", {
  state: () => ({
    socmed: [],
  }),
  getters: {},
  actions: {
    async getSocmed(params) {
      try {
        const res = await $fetch("/api/socmed/get-socmed", {
          method: "POST",
          body: params,
        });
        this.socmed = res.data;
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },
  },
});
